import React, { useCallback } from 'react';
import * as slice from "../../store/student/studentSlice";
import { useAppDispatch, useAppSelector } from "../../store/hook";
import { studentActions } from '../../store/student/studentSlice';

export const useStudent = () => {
    const dispatch = useAppDispatch();
    return {
        loadStudents: useCallback((payload) => {
            dispatch(studentActions.loadStudents(payload));
        }, [dispatch]),
        loadCurrent: useCallback((payload) => {
            dispatch(studentActions.loadCurrentStudent(payload));
        }, [dispatch]),
        save: useCallback((payload) => {
            dispatch(studentActions.saveCurrentStudent(payload));
        }, [dispatch]),
        create: useCallback((payload) => {
            dispatch(studentActions.createStudent(payload));
        }, [dispatch]),
        loadActivity: useCallback((payload) => {
            dispatch(studentActions.loadActivities(payload));
        }, [dispatch]),
        loadAssessmentSummary: useCallback((payload) => {
            dispatch(studentActions.loadAssessmentSummary(payload));
        }, [dispatch]),
        loadProgressSummary: useCallback((payload) => {
            dispatch(studentActions.loadProgressSummary(payload));
        }, [dispatch]),
        loadAssignmentProgress: useCallback((payload) => {
            dispatch(studentActions.loadAssignmentProgress(payload));
        }, [dispatch]),
        loadTeacherGrades: useCallback((payload) => {
            dispatch(studentActions.loadTeacherGrade(payload));
        }, [dispatch]),
        loadAssessmentResult: useCallback((payload) => {
            dispatch(studentActions.loadAssessmentResult(payload));
        }, [dispatch]),



        students: useAppSelector(slice.getStudents),
        teacherGrades: useAppSelector(slice.getTeachterGrades),
        current: useAppSelector(slice.getCurrentStudent),
        activities: useAppSelector(slice.getActivity),
        assessmentSummary: useAppSelector(slice.getAssessmentSummary),
        progressSummary: useAppSelector(slice.getProgressSummary),
        AssignmentProgressSummary: useAppSelector(slice.getAssignmentProgress),
        assessmentResult: useAppSelector(slice.getAssessmentResult),
        loading: useAppSelector(slice.isLoading),
        pagination: useAppSelector(slice.getPagination),
        // index: useAppSelector(slice.currentIndex),
    }
}